<template>
	<div id="tmpPage" class="text-center text-light p-4">
        <h1><b>TEMPORALMENTE INACTIVO</b></h1>
        <h2>El sitio web esta temporalmente inactivo debido a su mantenimiento.<br>Rogamos disculpen las molestias.</h2>
        <div>
            <img class="logo" :src="logoImage" alt="Logotipo de la empresa">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Mantenimiento',
        data() {
            return {
                logoImage: `${this.$Params.urlImages}logo`
            }
        }
    }
</script>

<style>
#tmpPage {
    background: rgba(0,0,0,.3);
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
}
</style>